import styled from 'styled-components';

import LoadingRadial from 'modules/UI/components/LoadingPlaceholder/components/LoadingRadial';

export const InputLoading = styled(LoadingRadial)`
  width: 20px;
  height: 20px;
  border-width: 2px;
`;
